// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const StatusRejectedIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M8 9.83333C7.72667 9.83333 7.5 9.60667 7.5 9.33333V6C7.5 5.72667 7.72667 5.5 8 5.5C8.27333 5.5 8.5 5.72667 8.5 6V9.33333C8.5 9.60667 8.27333 9.83333 8 9.83333Z" fill={fill} />
      <path d="M7.9999 12C7.9599 12 7.9133 11.9934 7.8666 11.9867C7.8266 11.98 7.7866 11.9667 7.7466 11.9467C7.7066 11.9334 7.6666 11.9134 7.6266 11.8867C7.5933 11.86 7.5599 11.8334 7.5266 11.8067C7.4066 11.68 7.3333 11.5067 7.3333 11.3334C7.3333 11.16 7.4066 10.9867 7.5266 10.86C7.5599 10.8334 7.5933 10.8067 7.6266 10.78C7.6666 10.7534 7.7066 10.7334 7.7466 10.72C7.7866 10.7 7.8266 10.6867 7.8666 10.68C7.9533 10.66 8.0466 10.66 8.1266 10.68C8.1733 10.6867 8.2133 10.7 8.2533 10.72C8.2933 10.7334 8.3333 10.7534 8.3733 10.78C8.4066 10.8067 8.4399 10.8334 8.4733 10.86C8.5933 10.9867 8.6666 11.16 8.6666 11.3334C8.6666 11.5067 8.5933 11.68 8.4733 11.8067C8.4399 11.8334 8.4066 11.86 8.3733 11.8867C8.3333 11.9134 8.2933 11.9334 8.2533 11.9467C8.2133 11.9667 8.1733 11.98 8.1266 11.9867C8.0866 11.9934 8.0399 12 7.9999 12Z" fill={fill} />
      <path d="M12.04 14.7732H3.96C2.66 14.7732 1.66665 14.2999 1.15999 13.4465C0.65998 12.5932 0.72665 11.4932 1.35999 10.3532L5.4 3.08656C6.06667 1.88656 6.98667 1.22656 8 1.22656C9.01333 1.22656 9.93333 1.88656 10.6 3.08656L14.64 10.3599C15.2733 11.4999 15.3467 12.5932 14.84 13.4532C14.3333 14.2999 13.34 14.7732 12.04 14.7732ZM8 2.22656C7.37333 2.22656 6.76 2.70656 6.27333 3.57323L2.24 10.8466C1.78665 11.6599 1.71332 12.4066 2.02665 12.9466C2.34 13.4866 3.03333 13.7799 3.96667 13.7799H12.0467C12.98 13.7799 13.6667 13.4866 13.9867 12.9466C14.3067 12.4066 14.2267 11.6666 13.7733 10.8466L9.72667 3.57323C9.24 2.70656 8.62667 2.22656 8 2.22656Z" fill={fill} />
    </svg>
  );
};

export { StatusRejectedIcon };
